/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const { RequestCommand } = require('./RequestCommands');

class ExecuteFunctionCommand extends RequestCommand {
	constructor(sheet, functionStr) {
		super(sheet);
		this.isVolatile = true;
		this._functionStr = functionStr;
	}

	getExecuteRequest() {
		return this.createRequest({ function: this._functionStr });
	}
	getRedoRequest() {}
	getUndoRequest() {}
	handleResult() {}
}
module.exports = ExecuteFunctionCommand;
